const getCleanUrl = () => {
  // Chatbot internal URL, (INSIDE THE IFRAME)
  return window.location.host.replace(/^www\./, '')
}

export const getTenantDomainUrl = () => {
  console.debug({ getTenantDomainUrl: getCleanUrl() })
  return getCleanUrl()
}
